import { render, staticRenderFns } from "./ProductCategoryView.vue?vue&type=template&id=132bcfc8&scoped=true"
import script from "./ProductCategoryView.vue?vue&type=script&lang=js"
export * from "./ProductCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132bcfc8",
  null
  
)

export default component.exports